/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown>, balance: NonNullable<unknown> }} Directory_Ai_Tools_Studio_Not_EnoughInputs */

const en_directory_ai_tools_studio_not_enough = /** @type {(inputs: Directory_Ai_Tools_Studio_Not_EnoughInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This video needs ${i?.credits} credits and you have ${i?.balance}. Pick a pack below to continue.`)
};

const zh_directory_ai_tools_studio_not_enough = /** @type {(inputs: Directory_Ai_Tools_Studio_Not_EnoughInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`这条视频需要 ${i?.credits} 积分，你目前有 ${i?.balance}。在下方选一个积分包继续。`)
};

/**
* | output |
* | --- |
* | "This video needs {credits} credits and you have {balance}. Pick a pack below to continue." |
*
* @param {Directory_Ai_Tools_Studio_Not_EnoughInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_not_enough = /** @type {((inputs: Directory_Ai_Tools_Studio_Not_EnoughInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_Not_EnoughInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_not_enough(inputs)
	return zh_directory_ai_tools_studio_not_enough(inputs)
});
export { directory_ai_tools_studio_not_enough as "directory.ai_tools.studio.not_enough" }